function downloadBlobFile(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.download = fileName;
  a.href = url;
  a.target = "_self";
  a.click();
  setTimeout(function () {
    a.remove();
    URL.revokeObjectURL(url);
  }, 100);
}

export { downloadBlobFile };
